module.exports = __webpack_public_path__ + "static/media/na.2a5f6f2b.svg";